module.exports = __webpack_public_path__ + "static/fonts/Nunito-Black.314d81d.woff";